//CRN_20251218 - ⚠️ ngOnInit() called for components/directives & not services ⚠️

import CustomStore from 'devextreme/data/custom_store';
import { ExceptionsService } from '../../general/exceptions-service';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { Injectable } from '@angular/core';
import { lastValueFrom, map, Observable, of } from 'rxjs';
import { MessageDefaultDeliveryTypes } from 'src/app/core/enums';

/**
 * Types Message Default Delivery Service
 * How a message type's built in default is sent when a company has configured no template of its own.
 * Mirrors PublicEnums.MessageDefaultDeliveryTypes in the API.
 */
@Injectable({ providedIn: 'root' })

export class TypesMessageDefaultDeliveryService {

  constructor(
    private exceptionsService: ExceptionsService
  ) { }

  public getIdAndDescription(): Observable<IdAndDescriptionDTO[]> {
    try {
      const deliveryData=[
        { "id": MessageDefaultDeliveryTypes.SMS  , "description": "SMS"         },
        { "id": MessageDefaultDeliveryTypes.Email, "description": "Email"       },
        { "id": MessageDefaultDeliveryTypes.Both , "description": "SMS & Email" }
      ];

      return of(deliveryData)
      .pipe(
        map(x => x.map(this.idAndDescriptionConverter))
      );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  private idAndDescriptionConverter(idAndDescription: IdAndDescriptionDTO) {
    return { id: idAndDescription.id, description: idAndDescription.description };
  }

  public idAndDescriptionLookupDataSource(): {} {
    try {
      return {
        store: new CustomStore({
          key: "id",
          loadMode: "raw",
          load: () => {
            return lastValueFrom(this.getIdAndDescription());
          }
        }),
        //RBW_20261020 - Sorted by id so it reads SMS, Email, SMS & Email rather than alphabetically.
        sort: "id"
      };
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return {};
    }
  }
}
